import React from "react";
import { Settings, User, Bell, Shield } from "lucide-react";

const MediaBuyerSettings = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10 p-6">
        <div className="flex items-center space-x-3 mb-4">
          <Settings className="w-6 h-6 text-[#B8460E]" />
          <h1 className="text-2xl font-bold text-white">Settings</h1>
        </div>
        <p className="text-gray-300 mb-6">
          Manage your account settings and preferences.
        </p>

        <div className="flex flex-col items-center justify-center py-12">
          <User className="w-16 h-16 text-gray-400 mb-4" />
          <p className="text-gray-400">Settings panel coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default MediaBuyerSettings;
